exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-activity-design-dropdown .activity-design-toggle{border-bottom:1px dotted var(--fts-border)}", ""]);

// exports
